<template>
  <div class="pl-1 pb-1 pb-md-0">
        <v-row  align-start justify-start  fill-height class="ml-0 pl-0">
            <span class="ml-0 text-body-2  text-md-caption" >{{thesis.department}}&nbsp;{{thesis.year_start}}</span>
        </v-row>
  </div>
</template>
<script>
export default {
  props:['thesis'],
}
</script>
